import { useState } from "react";
import { generarSesionCompleta } from "../sesion.logic";

const DEFAULT_PROGRESS = {
  mongo: { estado: "pendiente", progreso: 0, tiempo: 0 },
  word: { estado: "pendiente", progreso: 0, tiempo: 0 },
  pdf: { estado: "pendiente", progreso: 0, tiempo: 0 },
  html: { estado: "pendiente", progreso: 0, tiempo: 0 },
};

export const useSesionGeneration = ({ onFinish }) => {
  const [modalProgress, setModalProgress] = useState(DEFAULT_PROGRESS);
  const [generacionActiva, setGeneracionActiva] = useState(false);
  const [generateError, setGenerateError] = useState("");
  const [invalidPdfIds, setInvalidPdfIds] = useState([]);
  const [currentMongoStep, setCurrentMongoStep] = useState(null);

  const updateProgress = (step, estado, progreso, tiempo) => {
    setModalProgress(prev => ({
      ...prev,
      [step]: {
        estado,
        progreso: typeof progreso === "number" ? progreso : prev[step]?.progreso ?? 0,
        tiempo: typeof tiempo === "number" ? tiempo : prev[step]?.tiempo ?? 0,
      },
    }));
  };

  const addInvalidPdf = (id) => {
    setInvalidPdfIds(prev =>
      prev.includes(id) ? prev : [...prev, id]
    );
  };

  const startGenerate = async (sesion) => {
    if (generacionActiva) return;

    try {
      setGeneracionActiva(true);
      setGenerateError("");
      
      // REANUDACIÓN: Si ya existe un ID, marcamos Mongo como 'en_progreso' 
      // para que el usuario vea que el sistema está validando el avance previo.
      const hasMongoId = sesion.sesionGenerada_id || sesion.mongo_id;
      setModalProgress(hasMongoId 
        ? { ...DEFAULT_PROGRESS, mongo: { estado: "en_progreso", progreso: 0, tiempo: 0 } }
        : DEFAULT_PROGRESS
      );
      
      setCurrentMongoStep(null);

      await generarSesionCompleta({
        sesion,
        updateProgress,
        setCurrentMongoStep,
        onMongoCreated: () => {}, 
      });

      // Si terminó con éxito, lo quitamos de la lista de errores si existía
      setInvalidPdfIds(prev => prev.filter(id => id !== sesion.id));
      
      if (onFinish) onFinish();
    } catch (e) {
      console.error("Error en startGenerate:", e);
      setGenerateError(e.message || "Ocurrió un error durante la generación.");
    } finally {
      setGeneracionActiva(false);
    }
  };

  return {
    modalProgress,
    currentMongoStep,
    generacionActiva,
    generateError,
    invalidPdfIds,
    startGenerate,
    addInvalidPdf,
  };
};